import { useState, useEffect } from 'react';

// A simple debounce function to prevent the event from firing too often
function debounce(fn, ms) {
  let timer;
  return () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      fn.apply(this, arguments);
    }, ms);
  };
}

export function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    // Debounce the handler to avoid performance issues
    const debouncedHandleResize = debounce(function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }, 200); // 200ms delay

    window.addEventListener('resize', debouncedHandleResize);

    // Cleanup function to remove the event listener
    return () => window.removeEventListener('resize', debouncedHandleResize);
  }, []); // Empty dependency array means this effect runs only on mount and unmount

  return windowSize;
}
